import { createApp } from 'vue';
import './plugins/assets';
import {
  setupAppErrorHandle,
  setupAppVersionNotification,
  setupDayjs,
  setupIconifyOffline,
  setupLoading,
  setupNProgress
} from './plugins';
import { setupStore } from './store';
import { setupRouter } from './router';
import { setupI18n } from './locales';
import App from './App.vue';
import MyTable from './components/common/my-table.vue';
import MySelect from './components/common/my-select.vue';
import MyTreeSelect from './components/common/my-tree-select.vue';
// 注册全局组件
function registerGlobalComponents(app: any) {
  app.component('MyTable', MyTable);
  app.component('MySelect', MySelect);
  app.component('MyTreeSelect', MyTreeSelect);
}

async function setupApp() {
  setupLoading();

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  const app = createApp(App);

  registerGlobalComponents(app);

  setupStore(app);

  await setupRouter(app);

  setupI18n(app);

  setupAppVersionNotification();

  setupAppErrorHandle(app);

  app.mount('#app');
}

setupApp();
